import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Box, useResponsive } from '@otcmarketsgroup/otcm-ui-lib';
import VerifyBox from '../VerifyBox';
import NextButton from '../NextButton';

const SectionNextActions = ({ readOnly, section, linkTo, verifyBoxTestId, nextBtnTestId }) => {
    const { isDesktop } = useResponsive();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: isDesktop ? 'row' : 'column',
            justifyContent: 'end',
            gap: 2,
        }}>
            {!readOnly && <Box flex={1}>
                <VerifyBox section={section} data-testid={verifyBoxTestId} />
            </Box>}
            <Box>
                <Link to={linkTo}>
                    <NextButton data-testid={nextBtnTestId} />
                </Link>
            </Box>
        </Box>
    );
};

SectionNextActions.propTypes = {
    readOnly: PropTypes.bool,
    section: PropTypes.string,
    linkTo: PropTypes.string,
    verifyBoxTestId: PropTypes.string,
    nextBtnTestId: PropTypes.string
};

export default SectionNextActions;
